export const UPLOAD_LOAD_FILE = 'UPLOAD_LOAD_FILE';
export const GET_LOAD_FILES = 'GET_LOAD_FILES';
